import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const SelectProjectPlaceholder: React.FC = () => {
  return (
    <Box 
      sx={{
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100%',
        color: 'text.secondary',
        p: 3
      }}
    >
      <InfoOutlinedIcon sx={{ fontSize: 40, mb: 2 }} />
      <Typography variant="h6" component="div">
        Select a Project
      </Typography>
      <Typography variant="body1">
        Click on a project in the folder tree on the left to view its test cases.
      </Typography>
    </Box>
  );
};

export default SelectProjectPlaceholder; 